module.exports = __webpack_public_path__ + "img/AXA_logo.ac3e9dba.png";